import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { Paths } from '../../../enums/paths.enum';
import { RouteLabels } from '../../../enums/routeLabels.enum';
import { AuthGuard } from '../../../shared/auth.guard';
import { CanDeactivateGuard } from '../../../shared/can-deactivate.guard';
import { FxGuard } from '../guards/fx.guard';
import { GroupingAndMaskingGuard } from '../guards/grouping-and-masking.guard';
import { MappingGuard } from '../guards/mapping.guard';
import { FinancialStatementAccountMappingFormComponent } from '../import-balance-sheet/financial-statement-account-mapping-form/financial-statement-account-mapping-form.component';
import { FinancialStatementImportBalanceSheetComponent } from '../import-balance-sheet/financial-statement-import/financial-statement-import-balanceSheet.component';
import { FxRatesComponent } from '../import-balance-sheet/fx-rates/fx-rates.component';
import { GroupingMaskingComponent } from '../import-balance-sheet/grouping-masking/grouping-masking.component';
import { ImportRedirectPage } from './import-redirect/import-redirect.page';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', component: ImportRedirectPage, pathMatch: 'full' },
            {
                path: `${Paths.UPLOAD}`,
                component: FinancialStatementImportBalanceSheetComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_UPLOAD,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.MAPPING}`,
                component: FinancialStatementAccountMappingFormComponent,
                canActivate: [AuthGuard, MappingGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_MAPPING,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.GROUPING_MASKING}`,
                component: GroupingMaskingComponent,
                canActivate: [AuthGuard, GroupingAndMaskingGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_GROUPING_MASKING,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.FX}`,
                component: FxRatesComponent,
                canActivate: [AuthGuard, FxGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.FINANCIAL_STATEMENT_FX,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: '**',
                redirectTo: '',
                pathMatch: 'full',
            },
        ],
    },
];

@NgModule({
    declarations: [ImportRedirectPage],
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes)],
})
export class FinancialStatementImportModule {}